import { graphqlFetch } from '@api/graphql/gql-fetch';
import {
	type EditReviewResponse,
	type UpdateStorefrontReviewVariables,
	updateReviewMutation,
} from '@api/graphql/reviews/updateReview';
import { unifiedReviewsApiUrl } from '@settings';
import { Logger } from '@utils/logger/logger';

const headers = {
	'x-tenant-id': 'tk-us',
};

export const updateReviewFetch = async (
	variables: UpdateStorefrontReviewVariables,
	token: string,
) => {
	try {
		const result = await graphqlFetch<EditReviewResponse>({
			url: unifiedReviewsApiUrl,
			query: updateReviewMutation,
			variables,
			headers: new Headers({ ...headers, 'membership-session-token': token }),
		});

		if (result.errors?.length) {
			const errors = result.errors.map((error) => new Error(error.message));
			for (const error of errors) {
				Logger.error({
					log_message: 'GraphQL Error updating review',
					errorToLog: error,
					newRelic: true,
				});
			}
			throw errors;
		}

		return {
			data: {
				id: result.data.editReview.review.id,
			},
		};
	} catch (e) {
		if (!Array.isArray(e)) {
			Logger.error({
				errorToLog: e,
				newRelic: true,
				log_message: 'Error updating review',
			});
		}
		throw e;
	}
};
